import {
  FileItem,
  PasswordField,
  StrengthType,
} from '@pango-inc/keybox-sdk-wrapper/dist/sdk-wrapper.main';
import { LogLevels } from './types';

export const isWeakPassword = (passwordField: PasswordField): boolean => {
  return Boolean(
    passwordField.length > 0 &&
      (passwordField.strength?.type === StrengthType.Weak ||
        passwordField.strength?.type === StrengthType.Bad),
  );
};

type WaitUntilChecksOptions = {
  callback: (() => void) | (() => Promise<void>);
  checks: Array<() => boolean>;
  period: number;
  stopTime: number;
  stopTimeCallback?: (() => void) | (() => Promise<void>);
};
export function waitUntilChecksPass(options: WaitUntilChecksOptions) {
  if (Date.now() > options.stopTime && options.stopTimeCallback) {
    if (!options.stopTimeCallback) {
      return;
    }

    options.stopTimeCallback();
    return;
  }
  if (options.checks.every((check) => check())) {
    options.callback();
    return;
  }
  setTimeout(() => {
    waitUntilChecksPass(options);
  }, options.period);
}

// log levels
export const getSdkLogLevels = (): LogLevels => {
  const STORAGE_KEY_SDK_LOG_LEVELS = 'SDK_LOG_LEVELS_V1';
  const defaultLogLevels: LogLevels = {
    LoggerConfig: {
      // None = 0, Info = 1, Warning = 2, Error = 3, Debug = 4
      level: 0,
      // None = 0, Stdout = 1
      sink: 0,
    },
    WrapperLoggerConfig: {
      // INFO = 0, DEBUG = 1, TIME = 2, WARN = 3, ERROR = 4
      // all levels example = [0, 1, 2, 3, 4]
      level: [],
      // name of logger and levels example: {"WorkerInitialization: [0, 1, 2, 4]}
      loggers: {},
    },
  };
  try {
    const logLevelsJson = localStorage.getItem(STORAGE_KEY_SDK_LOG_LEVELS);
    if (!logLevelsJson) {
      localStorage.setItem(
        STORAGE_KEY_SDK_LOG_LEVELS,
        JSON.stringify(defaultLogLevels),
      );
    }
    return logLevelsJson
      ? (JSON.parse(logLevelsJson) as LogLevels)
      : defaultLogLevels;
  } catch {
    return defaultLogLevels;
  }
};
// log levels end

export const downloadFile = (file: FileItem, delay: number) => {
  setTimeout(() => {
    const link = document.createElement('a');
    // const content = file.content.split('base64A')[1];
    link.href = `data:application/octet-stream;base64,${file.content}`;
    link.download = file.info.name;

    const clickEvent = new MouseEvent('click');
    link.dispatchEvent(clickEvent);
  }, delay);
};
